import { render, staticRenderFns } from "./btn-primary.mpx?vue&type=template&id=62306ba4&isComponent&outputPath=components%2Fbtn-primary49a94057%2Findex"
import script from "./btn-primary.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-primary49a94057%2Findex"
export * from "./btn-primary.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-primary49a94057%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports